import Decision from "../Components/Decision";
import Footer from "../Components/Footer";
import Header from "./Header";
import CreateForm from "./CreateForm";
import EventList from "./EventList";
import withAuth from "../auth/withAuth";

const NewEvent = () => {
    
    return (
      <div>
        <Header/>
        <CreateForm />
        <Decision/>
        <Footer />
      </div>
    );
  }

  export default withAuth(NewEvent);